import React from 'react';
import { StepProgressBarProps } from '@/types';

// Componente de barra de progreso por pasos para profesionales
const StepProgressBarraProfe: React.FC<StepProgressBarProps> = ({ totalSteps, currentStep }) => {
  return (
    <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-4 px-4 max-w-full pt-14">
      {/* 🔹 Creamos un array con totalSteps elementos y lo iteramos */}
      {[...Array(totalSteps)].map((_, index) => (
        <React.Fragment key={index}>
          {/* 🔹 Línea antes del círculo, oculta en móviles para el primer paso */}
          {index !== 0 && (
            <div className="hidden sm:block w-10 h-0.5 bg-black" />
          )}

          {/* 🔹 Círculo del paso */}
          <div
            className={`w-8 h-8 sm:w-8 sm:h-8 min-w-[2rem] rounded-full flex items-center justify-center text-sm font-semibold ${
              currentStep === index + 1
                ? 'bg-black text-white border-2 border-blue-700'   // Paso actual
                : currentStep > index + 1
                ? 'bg-black text-white border-2 border-green-800' // Pasos completados
                : 'bg-white text-black border border-black'       // Pasos pendientes
            }`}
            style={{ fontWeight: currentStep === index + 1 ? '900' : '400' }} // Negrita para paso actual
          >
            {index + 1} {/* Número del paso */}
          </div>

          {/* 🔹 Línea después del círculo, oculta para el último paso */}
          {index !== totalSteps - 1 && (
            <div className="hidden sm:block w-10 h-0.5 bg-black" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepProgressBarraProfe;
